'use strict'; // for IE

if (typeof Promise === 'undefined') {
  require('@babel/polyfill');

  require('promise/lib/rejection-tracking').enable();

  window.Promise = require('promise/lib/es6-extensions.js');
} // Make sure we're in a Browser-like environment before importing polyfills
// This prevents `fetch()` from being imported in a Node test environment


if (typeof window !== 'undefined') {
  // fetch() polyfill for making API calls.
  require('whatwg-fetch');
} //classlist makes it easier to add and remove our open class
//to the hosting page's body


require('classlist-polyfill'); // for IE


Object.assign = require('object-assign');